import React, { useState, useEffect } from "react";
import moment from "moment";
import parse from "html-react-parser";

import SearchAndFilter from "../SearchAndFilter/SearchAndFilter";
import "./submittedqoutes.css";
import ListCardLeft from "./ListCardLeft";
import Header from "../Header/Header";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { ModalTandC } from "../ApplyNowRFQs/ModalTandC";
import { DownloadIcon, Button } from "evergreen-ui";
import { Markup } from "interweave";
import TermsAndCondition from "./TermsAndCondition";
import { IMAGE_PATH, PRODUCT } from "../../Utils/variables";

const SubmittedQoutes = () => {
  const [initialLoading, setinitialLoading] = useState(true);
  const [multiTandC, setmultiTandC] = useState([]);
  const [modalData, setmodalData] = useState({ title: "", desc: "" });
  const [remark, setremark] = useState("");

  // ---------------states for modal----------------------
  const [disablebtn, setDisableBtn] = useState(false);
  const [open, setOpen] = useState(false);
  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);
  const handleDisablebtn = () => setDisableBtn(true);

  const handleDownload = (urls) => {
    let url = urls;
    const link = document.createElement("a");
    link.href = url;
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  };
  // let vendorId = JSON.parse(localStorage.getItem("vendor_id"));
  const { isLogin, vendorId } = useSelector((state) => state.auth);
  const [grandTotal, setgrandTotal] = useState(0);
  const navigate = useNavigate();
  const [getFilterData, setgetFilterData] = useState({});
  const [activeTabId, setActiveTab] = useState(0);
  const [leftCardData, setleftCardData] = useState();
  const [rightCardData, setrightCardData] = useState();
  const [qouteId, setQouteId] = useState();
  const [basicClose, setbasicClose] = useState({
    card1: true,
    card2: true,
    card3: true,
    card4: true,
    card5: true,
    card6: true,
    card7: true,
    card8: true,
  });
  const onClickTabItem = (tabId) => {
    setActiveTab(tabId);
  };

  const openInNewTab = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const LeftCardDataLoad = (
    Communities,
    manageBy,
    closingOnstart,
    closingOnend,
    postedOnstart,
    postedOnend,
    search_query
  ) => {
    fetch(process.env.REACT_APP_API_URL + "/api/vendorRfq/quote", {
      method: "POST",
      body: JSON.stringify({
        vendor_id: vendorId,
        communities: Communities,
        manageBy: manageBy,
        closingOnstart: closingOnstart,
        closingOnend: closingOnend,
        postedOnstart: postedOnstart,
        postedOnend: postedOnend,
        search_query: search_query,
      }),
      headers: { "content-type": "application/json" },
    })
      .then((d) => d.json())
      .then((res) => {
        setleftCardData(res.response.data);
        if (res.response.count === 0) {
          setrightCardData();
          setQouteId("");
        } else {
          RightCardDataLoad(res.response.data[0].id);
          setQouteId(res.response.data[0].id);
        }

        setinitialLoading(false);
      })
      .catch((err) => {
        setinitialLoading(false);
        console.log("e", err);
      });
  };

  const FilterData = (
    Communities,
    manageBy,
    closingOnstart,
    closingOnend,
    postedOnstart,
    postedOnend
  ) => {
    let obj = {
      Communities,
      manageBy,
      closingOnstart,
      closingOnend,
      postedOnstart,
      postedOnend,
    };
    setgetFilterData(obj);
  };

  const RightCardDataLoad = (id) => {
    if (id) {
      fetch(process.env.REACT_APP_API_URL + "/api/vendorRfq/quoteById", {
        method: "POST",
        body: JSON.stringify({
          vendor_id: vendorId,
          quote_id: id,
        }),
        headers: { "content-type": "application/json" },
      })
        .then((d) => d.json())
        .then((res) => {
          setrightCardData(res.response[0]);
          const arr = res.response[0].quote_items;
          const sum = arr.reduce((accumulator, object) => {
            return accumulator + +object.total;
          }, 0);
          setgrandTotal(sum);

          const narr = res.response[0].tc;
          setmultiTandC(narr);
          const getRemark = res.response[0].term_condition_one[0] || "";
          setremark(getRemark);
        })
        .catch((err) => console.log("e", err));
    }
  };

  const searchFucntion = (x) => {
    LeftCardDataLoad(
      getFilterData.Communities,
      getFilterData.manageBy,
      getFilterData.closingOnstart,
      getFilterData.closingOnend,
      getFilterData.postedOnstart,
      getFilterData.postedOnend,
      x
    );
  };
  useEffect(() => {
    RightCardDataLoad(qouteId);
  }, [qouteId]);
  // useEffect(() => {
  //   LeftCardDataLoad();
  // }, []);
  useEffect(() => {
    LeftCardDataLoad(
      getFilterData.Communities,
      getFilterData.manageBy,
      getFilterData.closingOnstart,
      getFilterData.closingOnend,
      getFilterData.postedOnstart,
      getFilterData.postedOnend
    );
    document.title = PRODUCT + " - Submit Quote";
  }, [getFilterData]);

  return (
    <div className="routingSubContainer">
      <Header title={"Submitted Quotes"} />
      <div className="rfqHeadMainTopLevel">
        <SearchAndFilter
          FilterData={FilterData}
          closefilter={false}
          searchFucntion={searchFucntion}
        />
        <div className="rfqHeadMain">
          <div className="rfqLeftDiv">
            <div className="listMainDivHeading">
              <p className="listTopNameLeft">Submitted Quotes List</p>
              {/* <p className="listTopNameRight">31 Availiable</p> */}
            </div>
            <div className="listControlMainDiv">
              {leftCardData && leftCardData.length > 0 ? (
                leftCardData.map((e, i) => {
                  return (
                    <div
                      onClick={() => {
                        onClickTabItem(i);
                        setQouteId(e.id);
                      }}
                    >
                      <ListCardLeft
                        name={e.name}
                        closing_date={e.closing_date}
                        rfq_title={e.rfq_title}
                        activeTabId={activeTabId}
                        itemId={i}
                      />
                    </div>
                  );
                })
              ) : (
                <div className="noDataToShowList">
                  {initialLoading ? (
                    <i
                      className="fa fa-spinner fa-spin "
                      style={{
                        color: "var(--BaseDarkColor)",
                        fontSize: "40px",
                      }}
                    ></i>
                  ) : (
                    <img src={IMAGE_PATH + "submittedQuoteList.svg"} alt="" />
                  )}
                </div>
              )}
            </div>
          </div>
          {/* ---------------------right main data start from here--------------------- */}

          <div className="rfqRightDiv">
            <div className={rightCardData ? "rfqRightDivHead" : ""}>
              <div>
                <div className="rfqRightDivHeadHeading">
                  {rightCardData && rightCardData.rfq_title}{" "}
                </div>
                <div className="rfqRightDivHeadSubHeading">
                  {" "}
                  {rightCardData && rightCardData.name}
                </div>
              </div>
              <div>
                {rightCardData && rightCardData.length > 0 && (
                  <button
                    className="applyNowbtnRfq"
                    onClick={() => {
                      openInNewTab(
                        process.env.REACT_APP_NEW_TAB_URL + "/viewrfq"
                      );
                    }}
                  >
                    View RFQ
                  </button>
                )}
              </div>
            </div>
            {/* -----------------------right cards-------------------- */}
            {rightCardData ? (
              <div className="rfqRightDivData">
                {/* -----------basic info----------------- */}
                <div>
                  <div className="basicDetailsDivRfq">
                    <div>
                      <img src="./images/stratum/basicInfo.svg" alt="" />
                      <span className="rfqsrightdivSubName">General Info</span>
                    </div>
                    <div
                      className="basicDetailsDivRfqLogoDrop"
                      onClick={() => {
                        setbasicClose({
                          ...basicClose,
                          card1: !basicClose.card1,
                        });
                      }}
                    >
                      {" "}
                      <img
                        src="./images/stratum/dropUpLogo.svg"
                        className={!basicClose.card1 && "rotateSvg"}
                        alt=""
                      />
                    </div>
                  </div>
                  {basicClose.card1 && (
                    <div className="basicDetailsDivRfqColumDiv columnImpRfq">
                      <div>
                        <p>RFQ NO</p>
                        <div>
                          {rightCardData && rightCardData.rfq_no
                            ? rightCardData.rfq_no
                            : "NA"}
                        </div>

                        {/* <p>PR NO</p>
                      <div>
                        {rightCardData && rightCardData.pr_display_number
                          ? rightCardData.pr_display_number
                          : "NA"}
                      </div> */}

                        <p>CLOSING ON</p>
                        <div>
                          {rightCardData &&
                            moment(rightCardData.closing_date).format(
                              "DD MMM YYYY"
                            )}
                        </div>
                      </div>

                      <div>
                        <p>POSTED ON</p>
                        <div>
                          {rightCardData &&
                            moment(rightCardData.created_on).format(
                              "DD MMM YYYY"
                            )}
                        </div>
                        <p>Expected Completion/Delivery</p>
                        <div>
                          {rightCardData &&
                            moment(
                              rightCardData.expected_delivery_completion_date
                            ).format("DD MMM YYYY")}
                        </div>
                      </div>
                      {/* <div>
                        <p>MANAGED BY</p>
                      <div>{rightCardData && rightCardData.rfq_no}</div>
                      </div> */}
                    </div>
                  )}
                </div>
                {/* -----------site visit----------------- */}
                <div>
                  <div className="basicDetailsDivRfq">
                    <div>
                      <img src="./images/stratum/siteVisit.svg" alt="" />
                      <span className="rfqsrightdivSubName">Site Visit</span>
                    </div>
                    <div
                      className="basicDetailsDivRfqLogoDrop"
                      onClick={() => {
                        setbasicClose({
                          ...basicClose,
                          card8: !basicClose.card8,
                        });
                      }}
                    >
                      <img
                        src="./images/stratum/dropUpLogo.svg"
                        alt=""
                        className={!basicClose.card8 && "rotateSvg"}
                      />
                    </div>
                  </div>
                  {basicClose.card8 && (
                    <div className="basicDetailsDivRfqColumDiv columnImpRfq">
                      <div>
                        <p>start date</p>
                        <div>
                          {rightCardData &&
                            moment(rightCardData.site_visit_start_date).format(
                              "DD MMM YYYY"
                            )}
                        </div>
                        <p>end date</p>
                        <div>
                          {rightCardData &&
                            moment(rightCardData.site_visit_end_date).format(
                              "DD MMM YYYY"
                            )}
                        </div>
                      </div>
                      <div>
                        <p>start time</p>
                        <div>
                          {rightCardData && rightCardData.site_visit_start_time
                            ? rightCardData.site_visit_start_time
                            : "NA"}
                        </div>
                        <p>end time</p>
                        <div>
                          {rightCardData && rightCardData.site_visit_end_time
                            ? rightCardData.site_visit_end_time
                            : "NA"}
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                {/* -----------contact info----------------- */}
                <div>
                  <div className="basicDetailsDivRfq">
                    <div>
                      <img src="./images/stratum/contactinfo.svg" alt="" />
                      <span className="rfqsrightdivSubName">Contact Info</span>
                    </div>
                    <div
                      className="basicDetailsDivRfqLogoDrop"
                      onClick={() => {
                        setbasicClose({
                          ...basicClose,
                          card6: !basicClose.card6,
                        });
                      }}
                    >
                      <img
                        src="./images/stratum/dropUpLogo.svg"
                        className={!basicClose.card6 && "rotateSvg"}
                        alt=""
                      />
                    </div>
                  </div>
                  {basicClose.card6 && (
                    <div className="basicDetailsDivRfqColumDiv columnImpRfq">
                      <div>
                        <p>NAME</p>
                        <div>
                          {rightCardData && rightCardData.contact_person}
                        </div>
                        <p>NUMBER</p>
                        <div>
                          {rightCardData && rightCardData.vendor_phone
                            ? rightCardData.vendor_phone
                            : "NA"}
                        </div>
                      </div>
                      <div>
                        <p>EMAIL</p>
                        <div>
                          {rightCardData && rightCardData.email_id
                            ? rightCardData.email_id
                            : "NA"}
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                {/* -----------ITEMS---------------- */}
                <div>
                  <div className="basicDetailsDivRfq">
                    <div>
                      <img src="./images/stratum/item.svg" alt="" />
                      <span className="rfqsrightdivSubName">Items</span>
                    </div>
                    <div
                      className="basicDetailsDivRfqLogoDrop"
                      onClick={() => {
                        setbasicClose({
                          ...basicClose,
                          card2: !basicClose.card2,
                        });
                      }}
                    >
                      {" "}
                      <img
                        src="./images/stratum/dropUpLogo.svg"
                        className={!basicClose.card2 && "rotateSvg"}
                        alt=""
                      />
                    </div>
                  </div>
                  {basicClose.card2 && (
                    <div
                      className="basicDetailsDivRfqColumDiv"
                      id="basicDetailsDivRfqColumDivimp"
                    >
                      <table className="rfqtable">
                        <tr className="rfqtableHead">
                          <th>DESCRIPTION</th>
                          <th>UOM</th>
                          <th className="numberRightAlign">Qty</th>
                          <th className="numberRightAlign">PRICE PER UNIT</th>
                          <th className="numberRightAlign">VAT (%)</th>
                          <th className="numberRightAlign lastColumAlign">
                            TOTAL AMOUNT
                          </th>
                        </tr>
                        {rightCardData &&
                          rightCardData.quote_items.map((e) => {
                            return (
                              <tr className="rfqtablData">
                                <td>{e.item}</td>
                                <td>{e.uom_name}</td>
                                <td className="numberRightAlign">
                                  {e.quantity}
                                </td>
                                <td className="numberRightAlign">{e.amount}</td>
                                <td className="numberRightAlign">{e.vat}</td>
                                <td className="numberRightAlign lastColumAlign">
                                  {(+e?.total).toFixed(2)}
                                </td>
                              </tr>
                            );
                          })}
                        <tr className="rfqtablData">
                          <td></td>
                          <td></td>
                          <td colspan="3" id="grandTotalDiv">
                            Grand Total (AED)
                          </td>

                          <td
                            id="grandTotalDivval"
                            className="numberRightAlign lastColumAlign"
                          >
                            {grandTotal?.toFixed(2)}
                          </td>
                        </tr>
                      </table>
                    </div>
                  )}
                </div>
                {/* -----------scope of work---------------- */}

                <div>
                  <div className="basicDetailsDivRfq">
                    <div>
                      <img src="./images/stratum/scopeOfWork.svg" alt="" />
                      <span className="rfqsrightdivSubName">Scope of Work</span>
                    </div>
                    <div
                      className="basicDetailsDivRfqLogoDrop"
                      onClick={() => {
                        setbasicClose({
                          ...basicClose,
                          card7: !basicClose.card7,
                        });
                      }}
                    >
                      <img
                        src="./images/stratum/dropUpLogo.svg"
                        className={!basicClose.card7 && "rotateSvg"}
                        alt=""
                      />
                    </div>
                  </div>
                  {basicClose.card7 && (
                    <div className="basicDetailsDivRfqColumDiv">
                      <div>
                        <div className="rfqMaxWidth">
                          {rightCardData && rightCardData.scope_of_work
                            ? rightCardData.scope_of_work
                                .toString()
                                .replace(
                                  /<[^>]*(>|$)|&nbsp;|&zwnj;|&raquo;|&laquo;|&gt;/g,
                                  " "
                                )
                                .replace(/[\[\]']+/g, "")
                            : "no data to show"}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                {/* -----------Terms & Conditions -01---------------- */}
                {/* {multiTandC &&
                  multiTandC.map((e, i) => {
                    return ( */}

                <div>
                  <div className="basicDetailsDivRfq">
                    <div>
                      <img src="./images/stratum/tandc.svg" alt="" />
                      <span
                        className="rfqsrightdivSubName tandcClick"
                        onClick={() => {
                          // setmodalData({
                          //   title: multiTandC[i].title,
                          //   desc: multiTandC[i].desc,
                          // });
                          onOpenModal();
                        }}
                      >
                        Terms & Conditions
                      </span>
                      <br />
                      <span className="rfqsrightdivSubName tandcRemark">
                        Remark :
                      </span>
                    </div>
                    <div
                      className="basicDetailsDivRfqLogoDrop"
                      onClick={() => {
                        setbasicClose({
                          ...basicClose,
                          card3: !basicClose.card3,
                        });
                      }}
                    >
                      <img
                        src="./images/stratum/dropUpLogo.svg"
                        className={!basicClose.card3 && "rotateSvg"}
                        alt=""
                      />
                    </div>
                  </div>
                  {basicClose.card3 && (
                    <div className="basicDetailsDivRfqColumDiv">
                      <div>
                        <div className="rfqMaxWidth">{remark}</div>
                      </div>
                    </div>
                  )}
                </div>
                {/* ); */}
                {/* })} */}

                {/* -----------Notes--------------- */}

                <div>
                  <div className="basicDetailsDivRfq">
                    <div>
                      <img src="./images/stratum/notes.svg" alt="" />
                      <span className="rfqsrightdivSubName">Notes</span>
                    </div>
                    <div
                      className="basicDetailsDivRfqLogoDrop"
                      onClick={() => {
                        setbasicClose({
                          ...basicClose,
                          card5: !basicClose.card5,
                        });
                      }}
                    >
                      <img
                        src="./images/stratum/dropUpLogo.svg"
                        className={!basicClose.card5 && "rotateSvg"}
                        alt=""
                      />
                    </div>
                  </div>
                  {basicClose.card5 && (
                    <div className="basicDetailsDivRfqColumDiv">
                      <div>
                        <div className="rfqMaxWidth">
                          {rightCardData && rightCardData.notes
                            ? rightCardData.notes
                            : "NA"}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                {/* -----------Attachments----------------- */}
                <div>
                  <div className="basicDetailsDivRfq">
                    <div>
                      <img src="./images/stratum/attachment.svg" alt="" />
                      <span className="rfqsrightdivSubName">Attachments</span>
                    </div>
                    <div
                      className="basicDetailsDivRfqLogoDrop"
                      onClick={() => {
                        setbasicClose({
                          ...basicClose,
                          card8: !basicClose.card8,
                        });
                      }}
                    >
                      <img
                        src="./images/stratum/dropUpLogo.svg"
                        className={!basicClose.card8 && "rotateSvg"}
                        alt=""
                      />
                    </div>
                  </div>
                  {basicClose.card8 && (
                    <div className="basicDetailsDivRfqColumDiv columnImpRfq">
                      <div>
                        {/* <p></p>
                        <div>img1</div>
                        <p></p>
                        <div>img2</div> */}
                        {rightCardData &&
                          rightCardData.documents.map((item) => {
                            return (
                              <>
                                <p></p>
                                <div className="imageLabelId">
                                  {item.orig_name.slice(0, 20)}...
                                </div>
                              </>
                            );
                          })}
                      </div>
                      <div>
                        {/* <p></p>
                        <Button
                         marginY={8} 
                         marginRight={12} 
                         iconBefore={DownloadIcon}
                         onClick={handleDownload}
                         >
                          Download
                        </Button>
                        <p></p>
                        <div>
                          <img
                            src="./images/stratum/download.svg"
                            alt=""
                            className="dimg"
                          />
                          download2
                        </div> */}
                        {rightCardData &&
                          rightCardData.documents.map((item) => {
                            return (
                              <>
                                <p></p>
                                <Button
                                  className="downloadBtn poppinFont"
                                  // marginY={8}
                                  // marginRight={12}
                                  height={32}
                                  width={110}
                                  iconBefore={DownloadIcon}
                                  onClick={() => handleDownload(item?.urls)}
                                >
                                  Download
                                </Button>
                              </>
                            );
                          })}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <div className="noDataToShow">
                <img src={IMAGE_PATH + "submittedQuoteDetails.svg"} alt="svg" />
              </div>
            )}
          </div>
        </div>
      </div>
      <ModalTandC
        // title={modalData && modalData.title}
        // text={modalData && modalData.desc}
        data={multiTandC && multiTandC}
        open={open}
        onOpenModal={onOpenModal}
        onCloseModal={onCloseModal}
        handleDisablebtn={handleDisablebtn}
      />
    </div>
  );
};

export default SubmittedQoutes;
